enum StrategyLevelQueryType {
  GRADE_DATA_BY_ID = 'contentinfo,seocontentinfo',
  GRADE_DATA = 'strategytype,level,grade,field,contentinfo,seocontentinfo',
  APP_INITIAL_DATA = 'strategytype,level,grade,field,seocontentinfo',
}

export default StrategyLevelQueryType;
